import React from 'react'
import { Refinement } from 'lib/Refinement/types'

import CustomPriceRangeSlider from 'components/Filters/PriceRangeFilter/CustomPriceRangeSlider'

export const KEY = 'publicFilters.price.inCents'

export const priceRangeFilterRefinement: Refinement = {
  getQueryParamValue: ({ range }) =>
    range &&
    range[KEY] &&
    (range[KEY].min || range[KEY].max) && {
      priceRange: [range[KEY].min, range[KEY].max].join(':'),
    },
  getStateValue: ({ priceRange }) =>
    priceRange && {
      range: {
        [KEY]: (([min, max]) => ({
          min: min ? +min : undefined,
          max: max ? +max : undefined,
        }))((priceRange as string).split(':')),
      },
    },
}

const PriceRangeFilter = (): JSX.Element => (
  <CustomPriceRangeSlider attribute={KEY} />
)

export default PriceRangeFilter
